export default "__VITE_ASSET__aI3PKMKR__"